import React from 'react';
import KeyboardFormField from '@common/components/keyboardFormField';
import PropTypes from 'prop-types';

import { basicFields } from '../constants/fields';

export const BasicInformationForm = ({
  form, setForm, errors,
}) => {
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <div className="popup-main-content popup-register-wide-form">
      <div className="input-wrapper">
        {basicFields.map((item) => (
          <div className="register-single-input">
            <KeyboardFormField
              readOnly={item.readOnly}
              key={item.name}
              type={item.type}
              name={item.fieldName}
              value={form[item.name]}
              onChange={(value) => onChange(item.name, item.formatter ? item.formatter(value) : value)}
              errorMessage={errors[item.name]}
            />
          </div>
        ))}
      </div>
      
    </div>
  );
};

BasicInformationForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  errors: PropTypes.object,
};
